import permissions from "app/permissions";
import ListForeignLanguageCapacity from "./List";
import CreateForeignLanguageCapacity from "./Create";
import EditForeignLanguageCapacity from "./Edit";
import { FOREIGN_LANGUAGES, MANAGE_CAPACITY } from "utils/constants";

export const resources = {
  isMenu: false,
  name: MANAGE_CAPACITY + "/" + FOREIGN_LANGUAGES,
  title: "Капацитет",
  list: <ListForeignLanguageCapacity />,
  create: <CreateForeignLanguageCapacity />,
  edit: <EditForeignLanguageCapacity />,
  permission: permissions.canPreviewForeignLanguagesCapacities,
};
